import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInducedDraftCoolingTower = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 98,
	height: 70,
	viewBox: "0 0 98.0 70.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 24.0 70.0 L 19.0 60.0 L 24.0 60.0 L 0.0 10.0 L 34.0 10.0 L 34.0 0.0 L 64.0 0.0 L 64.0 10.0 L 98.0 10.0 L 74.0 60.0 L 79.0 60.0 L 74.0 70.0 Z M 34.0 10.0 L 64.0 10.0 M 24.0 60.0 L 74.0 60.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgInducedDraftCoolingTower;
